import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["row", "empty", "status", "search"]

  // Rows can arrive later via turbo_stream (live service updates), not just
  // on initial render, so each one is filtered as it connects rather than
  // only in response to the search/status controls changing.
  rowTargetConnected(row) {
    this.filterRow(row)
    this.updateEmptyState()
  }

  apply() {
    this.rowTargets.forEach((row) => this.filterRow(row))
    this.updateEmptyState()
  }

  filterRow(row) {
    const status = this.hasStatusTarget ? this.statusTarget.value : "all"
    const query = this.hasSearchTarget ? this.searchTarget.value.trim().toLowerCase() : ""
    const statusMatches = status === "all" || row.dataset.status === status
    const nameMatches = query === "" || row.dataset.name.includes(query)
    row.classList.toggle("hidden", !(statusMatches && nameMatches))
  }

  updateEmptyState() {
    if (!this.hasEmptyTarget) return
    const visible = this.rowTargets.some((row) => !row.classList.contains("hidden"))
    this.emptyTarget.classList.toggle("hidden", visible)
  }
}
